export class IRegisterUserMPTenant {
    tenantId: string = "";
    refreshToken: string = "";
    urlCallback: string = "";
}
